<template>
  <div class="container-c-status">
    <div class="status">
      <div class="status-active" v-if="arrowType === 'light'" @click="handleSelete">
        {{ activeStatu }}
        <img :class="{ activeImg: show }" src="@/assets/packageAssets/common/arrow06.png" alt="" />
      </div>
      <div class="status-active" v-if="arrowType === 'deep'" @click="handleSelete">
        {{ activeStatu }}
        <img :class="{ activeImg: show }" src="@/assets/packageAssets/common/arrow07.png" alt="" />
      </div>
      <div class="status-list" v-if="show">
        <div v-for="item in statuslist" :key="item.id" @click="handleClick(item.text, item)">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    activeStatu: '',
    statuslist: [],
    show: {
      default: false,
    },
    arrowType: {
      default: 'light',
    },
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    handleSelete() {
      this.show = !this.show
    },
    handleClick(text, item) {
      this.show = false
      this.$emit('selectStatus', text, item)
    },
  },
  watch: {},
  computed: {},
}
</script>
<style lang="scss" scoped>
.container-c-status {
  .status {
    position: relative;
    margin-left: 10px;
    font-size: 14px;
    font-family: 'Inter-Medium', 'Inter-Regular';
    font-weight: 500;
    color: #666666;
  }
  .status-active {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 108px;
    padding: 0 25px 0 16px;
    height: 30px;
    background: #ffffff;
    border-radius: 6px;
    > img {
      position: absolute;
      right: 4px;
      width: 16px;
    }
    .activeImg {
      rotate: 180deg;
    }
  }
  .status-list {
    // width: 100%;
    min-width: 108px;
    padding: 0 5px;
    position: absolute;
    top: 40px;
    left: 0;
    background-color: #f9f9fb;

    box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
    > div {
      display: block;
      width: 100%;
      height: 30px;
      margin: 5px 0;
      text-align: center;
      line-height: 30px;
      white-space: nowrap;
      font-weight: 500;
      color: #666666;
    }
  }
}
</style>
